





































































































import { mapGetters } from 'vuex';

import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';

import { IFetchTariffParams } from '@/services';

import CountryPicker from '../common/CountryPicker.vue';

export default mixins(auth).extend({
  name: 'TariffSearchFilter',

  components: {
    CountryPicker
  },

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      filterParams: {} as IFetchTariffParams
    };
  },

  computed: {
    ...mapGetters({
      getTariffTypeVisuals: 'tariff/getTariffTypeVisuals'
    }),

    openValue: {
      get(): boolean {
        return this.open;
      },
      set(val: boolean) {
        if (val === this.open) return;
        this.$emit('update:open', val);
      }
    }
  },

  methods: {
    closeSearchFilterDialog() {
      this.openValue = false;

      // reset filter params back to empty object
      this.resetFilterParams();
    },

    resetFilterParams() {
      this.filterParams = {};
    },

    openSearchFilterDialog(params: IFetchTariffParams) {
      if (params.destination_country != null) {
        this.filterParams.destination_country = params.destination_country;
      }

      if (params.tariff_type != null) {
        this.filterParams.tariff_type = Number(params.tariff_type);
      }

      this.openValue = true;
    },

    save() {
      this.$emit('change', this.filterParams);
      this.closeSearchFilterDialog();
    }
  }
});
